// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__BiPSN","checkIcon":"styles_checkIcon__3Yev4"};